import request from '../utils/request';

/**
 * 机器人推送分摊
 */
export const pushApportion = () => {
    return request({
        url: '/sys/tools/pushApportion',
        method: 'get',
        dataType: "json",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 机器人推送订单
 */
export const pushOrder = () => {
    return request({
        url: '/sys/tools/pushOrder',
        method: 'get',
        dataType: "json",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 机器人推送课时
 */
export const pushCourse = () => {
    return request({
        url: '/sys/tools/pushCourse',
        method: 'get',
        dataType: "json",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};
/**
 * 机器人推送定金
 */
export const pushAdvance = () => {
    return request({
        url: '/sys/tools/pushAdvance',
        method: 'get',
        dataType: "json",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};


/**
 * 机器人推送器材
 */
export const pushEquip = () => {
    return request({
        url: '/sys/tools/pushEquip',
        method: 'get',
        dataType: "json",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 机器人推送招商业绩
 */
export const pushZhaoShangCRMOrder = () => {
    return request({
        url: '/sys/tools/pushZhaoShangCRMOrder',
        method: 'get',
        dataType: "json",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 调用批量挪课时
 */
export const postBatchMoveCourse = (query) => {
    return request({
        url: 'sys/web_batchMoveCourse/add',
        method: 'POST',
        data: JSON.stringify(query),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};


/**
 * 调用批量-转移校区中的 部分订单
 */
export const partOrderMoveArea = (file) => {
    return request({
        url: '/sys/orders/partOrderMoveArea',
        headers: {
            "Content-type": "multipart/form-data",
        },
        method: 'post',
        data: file
    });
};

/**
 * 导入-固化上月底的分摊往期金额
 * @param file
 * @returns {AxiosPromise}
 */
export const importOrderBalance = (file) => {
    return request({
        url: '/sys/orderBalance/importOrderBalance',
        headers: {
            "Content-type": "multipart/form-data",
        },
        method: 'post',
        data: file
    });
};


/**
 * 推送课消
 */
export const sendKeXiao = (file) => {
    return request({
        url: 'sys/tools/pushStatisticsConsume',
        method: 'POST',
        headers: {
            "Content-type": "multipart/form-data",
        },
        data: file
    });
};
/**
 * 推送业绩
 */
export const sendYeJi = (file) => {
    return request({
        url: 'sys/tools/pushStatisticsPerformance',
        method: 'POST',
        headers: {
            "Content-type": "multipart/form-data",
        },
        data: file
    });
};
export const pushReturnVisitRate = (file) => {
    return request({
        url: 'sys/tools/pushReturnVisitRate',
        method: 'POST',
        headers: {
            "Content-type": "multipart/form-data",
        },
        data: file
    });
};
/**
 * 推送合同完成率
 */
export const contractRate = (file) => {
    return request({
        url: 'sys/tools/pushContractRate',
        method: 'POST',
        headers: {
            "Content-type": "multipart/form-data",
        },
        data: file
    });
};
//推送完成率
export const pushEfficiencyRatio = (file) => {
    return request({
        url: 'sys/tools/pushEfficiencyRatio',
        method: 'POST',
        headers: {
            "Content-type": "multipart/form-data",
        },
        data: file
    });
};
//推送试课转化
export const pushTraineeRatio = (file) => {
    return request({
        url: 'sys/tools/pushTraineeRatio',
        method: 'POST',
        headers: {
            "Content-type": "multipart/form-data",
        },
        data: file
    });
};
//推送引流转化
export const pushOrderDivert = () => {
    return request({
        url: 'sys/tools/pushOrderDivert',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};
//推送有价值出勤
export const pushWeekAttRatio = () => {
    return request({
        url: 'sys/tools/pushWeekAttRatio',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};
//导入 每月3日固定后的 业绩
export const importMonthMoney = (file) => {
    return request({
        url: 'sys/fixedPerformance/importFixedPerformance',
        method: 'POST',
        headers: {
            "Content-type": "multipart/form-data",
        },
        data: file
    });
};

//导入 每月3日固定后的 课消
export const importMonthCourse = (file) => {
    return request({
        url: 'sys/fixedConsume/importFixedConsume',
        method: 'POST',
        headers: {
            "Content-type": "multipart/form-data",
        },
        data: file
    });
};
